(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["counter-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  const counters = document.querySelectorAll(".counter-box h3");

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let counter = entry.target;
        let target = parseInt(counter.innerText);
        let duration = 2000;
        let startTime = null;

        function animateCounter(timestamp) {
          if (!startTime) startTime = timestamp;
          let progress = timestamp - startTime;
          let value = Math.min(Math.floor((progress / duration) * target), target);

          counter.innerText = value + "+";

          if (progress < duration) {
            requestAnimationFrame(animateCounter);
          }
        }

        requestAnimationFrame(animateCounter);

        observer.unobserve(counter); // run only once
      }
    });
  }, { threshold: 0.4 }); // 40% visible

  counters.forEach(counter => observer.observe(counter));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-choose-pipecowa"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  const counters = document.querySelectorAll(".pipecowa-stat h3");

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let counter = entry.target;
        let target = parseInt(counter.innerText);
        let duration = 2000;
        let startTime = null;

        function animateCounter(timestamp) {
          if (!startTime) startTime = timestamp;
          let progress = timestamp - startTime;
          let value = Math.min(Math.floor((progress / duration) * target), target);

          counter.innerText = value + "+";

          if (progress < duration) {
            requestAnimationFrame(animateCounter);
          }
        }

        requestAnimationFrame(animateCounter);

        observer.unobserve(counter); // run only once
      }
    });
  }, { threshold: 0.4 }); // 40% visible

  counters.forEach(counter => observer.observe(counter));
});

  } catch(e) { console.error(e); }
})();
})();
